export default {
    getRequestError(state){
      return state.request_error;
    },
    getInventory(state) {
      return state.inventory_of_search;
    },
    getSelectedInventory(state) {
      return state.selected_inventory;
    },
  };